<mat-toolbar color="accent">
  <div class="content responsive-container">
    <span>&copy; 2025 Trinetra. All rights reserved.</span>
  </div>
</mat-toolbar>
